import type { BuilderUIEmailTheme } from "@/react/types/EmailTheme";
import type { MarketingEmailTemplate } from "@/react/types/MarketingEmailTemplates";
import { BuilderUI } from "../../../BuilderUI";
import { createBlockRendererMapping } from "../../../BuilderUI/Helpers/blockMappings";
import { BlockRenderer } from "../../../BuilderUI/Renderer/BlockRenderer";
import { BroadcastTipTapReadonlyView } from "../../EmailPreview/BroadcastTipTapReadonlyView";
import { blocks } from "../../VisualEmailBuilder/Blocks";
import { GooberContextProvider } from "../../VisualEmailBuilder/Design/GooberContext";
import { SgIdProvider } from "../../VisualEmailBuilder/EditorFields/RichTextField/SgIdProvider";
import { EmailFrame } from "../../VisualEmailBuilder/EmailFrame";

const components = createBlockRendererMapping(blocks);

interface ContentRendererProps {
  content?: MarketingEmailTemplate["content"];
  template?: MarketingEmailTemplate;
  theme: BuilderUIEmailTheme;
}

export const ContentRenderer = ({
  template,
  content,
  theme,
}: ContentRendererProps) => {
  const isTipTap = !template || template.content_type === "tip_tap_email";

  if (isTipTap) {
    const contentToRender = template?.content || content;
    if (!contentToRender) return null;
    return <BroadcastTipTapReadonlyView content={contentToRender} />;
  }

  if (template?.visual_email_builder_content) {
    return (
      <SgIdProvider>
        <BuilderUI.Provider
          theme={theme}
          block={template.visual_email_builder_content.content}
          inlineAttachments={
            template.visual_email_builder_content.inline_attachments
          }
          canvasSize="desktop"
        >
          <EmailFrame>
            <GooberContextProvider>
              <BlockRenderer
                components={components}
                block={template.visual_email_builder_content.content}
              />
            </GooberContextProvider>
          </EmailFrame>
        </BuilderUI.Provider>
      </SgIdProvider>
    );
  }

  return null;
};
